<template>
	<div class="ql-container ql-snow">
	    <div class="ql-editor">
	        <div v-html="policyContent"></div>
	    </div>
	</div>
</template>

<script>
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	export default {
		name: 'QuillRich',
		props: {
		  
		},
		components: {
			// ScrollView,
		},
		data() {
			return {
				policyContent: '<p>list<br>9999</p>',
			}
		},
		methods: {
			
		},
	};
</script>

<style>
	
</style>